import { useReduxSelector } from 'services/hooks';

import { GamifiedEducationPage } from './gamified-education-page';
import { Education } from './education';

/**
 * Checks if gamified education is enabled and renders the gamified education screen if yes, otherwise renders the default education screen
 */
export const EducationProxy = () => {
  // Is gamified education mod enabled and not passed
  const isGamifiedEducation = useReduxSelector((redux) =>
    Boolean(redux.app.gameMods?.gamifiedEducation)
  );

  // If yes - render gamified education, if not - render default education.
  return isGamifiedEducation ? <GamifiedEducationPage /> : <Education />;
};
